import React from "react";

import { SprintAccessRight } from "./SprintAccessRight";
import { useAccessVerifier } from "./useAccessVerifier";

export type AuthorizationWrapperProps = React.PropsWithChildren<{
    accessRights: SprintAccessRight[];
}>;

export const AuthorizationWrapper: React.FunctionComponent<AuthorizationWrapperProps> = (
    props: AuthorizationWrapperProps
) => {
    const { accessRights, children } = props;

    const { isAuthorized } = useAccessVerifier();

    if (!accessRights.length) {
        throw new Error("No authorized roles defined.");
    }

    if (isAuthorized(accessRights)) {
        return <>{children}</>;
    }

    return <></>;
};
